import React from "react";
import ReactApexChart from "react-apexcharts";

class LearningDomainsChart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      series: [],
      options: {
        chart: {
          height: 360,
          type: "area",
          toolbar: { show: false },
          dropShadow: {
            enabled: true,
            top: 10,
            blur: 10,
            opacity: 0.1,
          },
        },
        colors: ["#FFAB2D", "#AC4CBC", "#28a745"],
        dataLabels: {
          enabled: true,
          style: { fontSize: '12px', colors: ['#444'] },
        },
        stroke: {
          curve: "smooth",
          width: 3,
        },
        markers: {
          size: 5,
        },
        fill: {
          type: "gradient",
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.4,
            opacityTo: 0.05,
            stops: [0, 90, 100],
          },
        },
        xaxis: {
          categories: [],
          labels: {
            style: {
              fontSize: "14px",
              fontFamily: "Cairo",
              colors: "#787878",
            },
          },
        },
        yaxis: {
          labels: {
            formatter: (val) => `${val}%`,
          },
        },
        tooltip: {
          y: {
            formatter: (val) => `${val}%`,
          },
        },
      },
    };
  }

  async componentDidMount() {
    try {
      const response = await fetch("https://plo.areez.co/api/main_domain/category/comparison/last");
      const json = await response.json();
  
      // 1. جميع أسماء الجامعات
      const universityNames = json.map(u => u.university_name);
  
      // 2. استخراج جميع أسماء المجالات (من أول جامعة فقط نفترض أنها ثابتة)
      const domainLabels = json[0]?.categories.map(c => c.domain_label) || [];
  
      // 3. بناء الـ series لكل مجال
      const newSeries = domainLabels.map((label, index) => ({
        name: label,
        data: json.map(u => parseFloat(u.categories[index].average_pct.toFixed(2)))
      }));
  
      // 4. تحديث الحالة
      this.setState({
        series: newSeries,
        options: {
          ...this.state.options,
          xaxis: {
            ...this.state.options.xaxis,
            categories: universityNames,
          },
        },
      });
    } catch (err) {
      console.error("خطأ في تحميل البيانات:", err);
    }
  }
  

  render() {
    return (
      <div id="chart">
        <ReactApexChart
          options={this.state.options}
          series={this.state.series}
          type="area"
          height={320}
        />
      </div>
    );
  }
}

export default LearningDomainsChart;
